import { TwoFactorAppSetup } from "@/components/Portal/UserAccount/Security/Change/TwoFactorAppSetup";

export const TwoFactorSetupAppView = () => <TwoFactorAppSetup />;
